import styled from "@emotion/styled";

import { QueryColumnInfoIcon } from "metabase/components/MetadataInfo/ColumnInfoIcon";

export const InfoIcon = styled(QueryColumnInfoIcon)`
  position: relative;
  left: 0.25rem;
`;
